// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b96d350","743":"ad602d12"}[chunkId] + ".chunk.js";
};